import React, { useRef, useState } from "react";
import { Ptag } from "../fonts";
import UploadedFileName from "components/UploadFileName";
import { DownloadButton, Error, UploadButton, UploadWrapper } from "./styles";
import UploadIcon from  "assets/svgs/uploadFile.svg";
import DownloadIcon from "assets/svgs/downloadNew.svg";
import { Label } from "components/PlanSetup/styles";

const acceptedFileFormats = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
];

const FileUploader = ({ label, text, showError, onSelect, bottom, isDisabled }) => {
  const inputRef = useRef();
  const [file, setFile] = useState(null);
  const [chartFormat, setFormat] = useState({name:'', size:''})
  const onChange = async (e) => {
    const file = e.currentTarget.files[0];
    const { type } = file;
    // if (!acceptedFileFormats.includes(type)) {
    //   alert("Please upload file in correct format");
    //   return;
    // }
    setFile(file);
    onSelect(file);
    setFormat({name:file.name,size:file.size})
  };
  const resetFile = () =>{
    setFile(null)
    onSelect(null)
    setFormat(null)
  }

  const downloadTemplate = () => {
    const templateUrl = "https://getvitalimages.s3.ap-south-1.amazonaws.com/images/GMC+RATE+CHART.xlsx"
    window.open(templateUrl, "_blank")
  }

  return (
    <>
      <div style={{'display': 'flex', 'flexDirection': 'row', 'justifyContent': 'space-between', 'alignItems': 'center', 'marginTop': '20px'}}>
        <Label>{label}</Label>
        <DownloadButton 
            onClick={downloadTemplate}
          >
            <img
              style={{  'marginRight': '3px', 'height': '21px', 'width': '21px' }}
              src={DownloadIcon}
              height="17px"
              width="14px"
            />
            <Ptag
              textAlign="center"
              fontSize="14px"
              fontWeight="600"
              color="white"
              fontFamily="Montserrat"
            >
              {"Download Excel Format"}
            </Ptag>
        </DownloadButton>
      </div>
      <UploadWrapper>
        <UploadButton onClick={() => inputRef.current.click()}>
          <img
            style={{ marginRight: "6px", height: "16px", width : "14px" }}
            src={UploadIcon}
            height="20px"
            width="17px"
          />
          <input
            ref={inputRef}
            type="file"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf"
            onChange={onChange}
            disabled={isDisabled && isDisabled.length>1} 
          />
          <Ptag
            fontSize="14px"
            fontWeight="600"
            letterSpacing="0.44px"
            letterHeight="19px"
          >
            {text}
          </Ptag>
        </UploadButton>
        {showError && !file && <Error bottom={bottom}>*Required</Error>}
        { file && <UploadedFileName file={chartFormat} onClick={resetFile}/>}
        
      </UploadWrapper>
    </>
  );
};

export default FileUploader;
